import { useRef, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { destinations, type Destination } from '../data/destinations';
import { ArrowRight, MapPin } from 'lucide-react';

interface DestinationsProps {
  items?: Destination[];
  header?: ReactNode;
}

export default function Destinations({ items = destinations, header }: DestinationsProps) {
  const sectionRef = useRef<HTMLElement>(null);

  return (
    <section ref={sectionRef} id="destinations" className="section-padding relative">
      <div className="global-container max-w-[1280px]">
        {header}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((dest) => (
            <div key={dest.slug}>
              <Link
                to={`/destinations/${dest.slug}`}
                className="group block h-full relative liquid-glass rounded-2xl p-8 hover:bg-white/[0.06] transition-all duration-500 border border-white/5 hover:border-white/10"
              >
                <div className="flex items-center gap-3 mb-12">
                  <div className="w-8 h-8 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                    <MapPin className="w-4 h-4 text-blue-400" />
                  </div>
                  <span className="text-blue-400/60 text-[10px] font-bold tracking-[0.2em] uppercase">
                    {dest.category} / {dest.country}
                  </span>
                </div>

                <h3 className="font-serif text-2xl mb-4 group-hover:text-primary transition-colors">{dest.name}</h3>
                <p className="text-secondary/70 text-sm leading-relaxed mb-8">
                  {dest.summary}
                </p>

                <div className="flex items-center gap-2 text-white/30 group-hover:text-white transition-colors text-xs font-bold tracking-widest uppercase">
                  Explore Node
                  <ArrowRight className="w-3.5 h-3.5 transform group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
